import React from 'react';
import HeaderButton from "./button";
import {Dropdown} from "semantic-ui-react";

const HeaderDropdown = ({value, icon, onChange, options, withLeftLine, label, ...p}) => {
    const trigger = <HeaderButton
        icon={icon}
        name={label ? label : (options.find(o => o.value === value) || {}).text}
        withLeftLine={withLeftLine}
    />;

    return (
        <Dropdown
            {...p}
            className={`header-dropdown dropdown-style ${label ? 'with-label' : ''}`}
            onChange={onChange}
            value={value}
            trigger={trigger}
            options={!label && options}
        >
            {label && <Dropdown.Menu>
                {
                    options.map(o => <Dropdown.Item key={o.key} onClick={o.onClick}>
                        {o.text}
                    </Dropdown.Item>)
                }
            </Dropdown.Menu>}
        </Dropdown>
    );
};

export default HeaderDropdown;


// WEBPACK FOOTER //
// ./App/pages/reports/components/dropdown.jsx